// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../../node_modules/modern-normalize/modern-normalize.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/icons/openEye.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans&family=Roboto:wght@300;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --app-height: 100%;
}

#root {
  height: 100%;
  /* min-width: 1024px; */
}

html,
body {
  font-size: 13px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  /* width: 100vw;
   */
  height: 100%;
  /* height: 100vh; */
  /* @media not all and (hover:hover) {
       height: var(--app-height);
   } */
}

.App {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: #426ba6;
  width: 100%;
  height: 100%;
  /* height: var(--app-height);     */
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: #f4f4f4;
}

.textFormat {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: #426ba6;
}

.App,
button,
input,
table {
  font-family: "Roboto";
  color: #426ba6;
}

.App__container {
  width: 100%;
  /* max-width: 1980px;
  min-width: 1024px; */
  display: flex;
  justify-content: center;
  height: 100%;
  overflow-y: auto;
  /* padding-bottom: 4.2em; */
  /* overflow-x: scroll; */
}
.App__container table {
  font-size: 11px;
  line-height: 12px;
}
.App__container .fixed_button {
  font-size: 13px;
}

.limitedSize {
  width: 100%;
  max-width: 1980px;
  margin-top: 4.2em;
  height: calc(100% - 4.2em);
  border: 6px solid #a3b9d9;
  border-top: 10px solid #a3b9d9;
  border-radius: 1px 1px 1px 1px;
  position: relative;
  flex-wrap: wrap;
  box-sizing: border-box;
  min-height: calc(576px - 4.2em);
}

.limitedSize__container {
  width: 100%;
  min-width: 1012px;
  position: relative;
  height: 100%;
  overflow-x: visible;
  padding: 0.5em 1.5em 0 1.5em;
}

.limitedSize_label {
  position: absolute;
  display: block;
  top: -2.5em;
  left: -6px;
  font-size: 1em;
  font-weight: 400;
  color: #426ba6;
  background-color: #a3b9d9;
  border-radius: 1px 1px 1px 0px;
  padding: 0 0.9em 0 1.1em;
  line-height: 1.5em;
}

.limitedSize__container.controlled {
  padding-bottom: 2.5em;
}

.overflow_container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow-x: auto;
}

input {
  font-size: 1em;
}

input[type=checkbox] {
  width: 1.2em;
  height: 1.2em;
}

/* @media screen and (min-width: 1805px) {
  .App{
    font-size: 15px;
    line-height: 18px;
  }
  .App table{
    font-size: 13px;
    line-height: 15px;
  }
  .error{
    font-size: 13px;
  }
} */
/* @media screen and (min-width: 3740px) {
  .App {
    font-size: 1.9rem;
    line-height: 2em;
  }
  .fixed_button{
    font-size: 1.7rem;
  }
  .App table {
    font-size: 1.8rem;
    line-height: 1.9rem;
  } */
/* .App .fieldWithSample input[type="checkbox"]{
    width: 2rem;
    height: 2rem;
  }
  .App input[type=checkbox]{
    width: 1.2em;
    height: 1.2em;
  }  */
/* } */
/* swal password styles*/
.swalPasswordWrapper {
  position: relative;
}

.swalPasswordInput {
  width: 100%;
  margin: 0;
  padding-right: 40px;
}

.swalShowPasswordBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  width: 30px;
  height: 30px;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  transition: transform 200ms ease-in-out;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.swalShowPasswordBtn:active {
  transform: translate(0px, 1px);
}

.labelWrap {
  white-space: nowrap;
}

.db {
  display: block;
}

.flexG {
  flex-grow: 1;
}

.row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

.fGrow {
  flex-grow: 1;
}

.fShrink {
  flex-shrink: 1;
}

.centered {
  margin: 0 auto;
}

.centeredFull {
  margin: auto;
}

.br {
  border-radius: 5px;
}

h1 {
  font-weight: 500;
  line-height: 15.23px;
  font-size: 1em;
  margin-bottom: 10px;
}
h1.centered {
  width: 100%;
  text-align: center;
}

.tac {
  text-align: center;
}

.project_form {
  height: 100%;
}

.list_container {
  width: 100%;
  height: 120px;
  overflow-x: hidden;
  background: #ffffff;
  margin-bottom: 5px;
  border: rgba(66, 108, 166, 0.5058823529);
}

.grid2_3 {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr 1fr 1fr;
}

.grid2_5 {
  display: grid;
  grid-template: 2fr 1fr/1fr 1fr 1fr 1fr auto;
  width: 100%;
  column-gap: 10px;
}

.flex_form {
  display: flex;
  flex-direction: column;
}

.flex_container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.fc {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.fc {
  display: flex;
  align-items: center;
}
.fc .fi50 {
  flex-basis: 50%;
}
.fc .fi60 {
  flex-basis: 60%;
}
.fc .fi70 {
  flex-basis: 70%;
}

.fdc {
  flex-direction: column;
}

.fcc {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.fcCol {
  display: flex;
  flex-direction: column;
}

.nowrap {
  flex-wrap: nowrap;
}

.space-between {
  justify-content: space-between;
}

.jcsb {
  justify-content: space-between;
}

.jcsa {
  justify-content: space-around;
}

.jcc {
  justify-content: center;
}

.jcfe {
  justify-content: flex-end;
}

.jcfs {
  justify-content: flex-start;
}

.aic {
  align-items: center;
}

.aife {
  align-items: flex-end;
}

.aist {
  align-items: flex-start;
}

.aibl {
  align-items: baseline;
}

.aistr {
  align-items: stretch;
}

.alsc {
  align-self: center;
}

.fd {
  flex-direction: column;
}

.fdr {
  flex-direction: row;
}

.gap {
  gap: 1rem;
}

.gap0_7 {
  gap: 0.7rem;
}

.gap1_5 {
  gap: 1.5rem;
}

.gap2x {
  gap: 2rem;
}

.gap5 {
  gap: 5px;
}

.halfBasis {
  flex-basis: 50%;
}

.pl {
  padding-left: 1rem;
}

.pr {
  padding-right: 1rem;
}

.pb {
  padding-bottom: 1rem;
}

.mba {
  margin-bottom: auto;
}

.mb {
  margin-bottom: 1rem;
}

.mb1_5x {
  margin-bottom: 1.5rem;
}

.mb2x {
  margin-bottom: 2rem;
}

.mb5 {
  margin-bottom: 5px;
}

.noShrink {
  flex-shrink: 0;
}

.g2 {
  gap: 2em;
}

.g1 {
  gap: 1em;
}

.g15 {
  gap: 1.5em;
}

.fGrow {
  flex-grow: 1;
}

.mt {
  margin-top: 1rem;
}

.mt0_5 {
  margin-top: 0.5rem;
}

.mt2x {
  margin-top: 2rem;
}

.mt3x {
  margin-top: 3rem;
}

.page_container {
  margin: 0 1%;
  padding-top: 5px;
  height: 100%;
}

.form_wrapper {
  width: 100%;
  min-width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: visible;
  position: relative;
}

.w100 {
  width: 100%;
}

.w90 {
  width: 90%;
}

.h100 {
  height: 100%;
}

.reactTableRow {
  cursor: pointer;
}
.reactTableRow:hover, .reactTableRow:active {
  background-color: rgba(191, 205, 226, 0.2941176471);
}

.app__logo {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 10;
}
.app__logo.left {
  right: unset;
  left: 5px;
}

.app__logo--right {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 10;
}

.tdn {
  text-decoration: none;
}

button.bigBtn {
  height: 2.5rem;
  padding: 8px;
  border-radius: 7px;
}

.qrContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
}

#qrCodeContainer2 {
  width: 100%;
  border: 1px solid #a3b9d9;
  background: white;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#qrCodeContainer2 video {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

@media screen and (min-width: 280px) {
  .skuInput {
    width: 150px;
  }
  button.bigBtn {
    height: 2rem;
    padding: 6px;
  }
}
@media screen and (min-width: 370px) {
  div input.skuInput {
    width: 200px;
  }
}
@media screen and (min-width: 500px) {
  div input.skuInput {
    width: 300px;
  }
}
.Toastify__toast-container--top-center {
  top: 30vh !important;
  position: fixed !important;
  width: 90% !important;
  left: 5% !important;
  transform: none !important;
}

.skuActionTable {
  max-height: 50dvh;
}

@media screen and (max-height: 600px) {
  .skuActionTable {
    height: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/App/style/App.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;AACF;;AAEA;;EAEE,eAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA;IAAA;EAEA,YAAA;EACA,mBAAA;EACA;;MAAA;AAGF;;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAEA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;;;;EAIE,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA;sBAAA;EAEA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EAEA,2BAAA;EAEA,wBAAA;AADF;AAEE;EACE,eAAA;EACA,iBAAA;AAAJ;AAEE;EACE,eAAA;AAAJ;;AAGA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,+BAAA;AAAF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EAEA,YAAA;EACA,mBAAA;EACA,4BAAA;AAAF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;AACF;;AACA;EACE,qBAAA;AAEF;;AAAA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,cAAA;AAGF;;AADA;EACE,YAAA;EACA,aAAA;AAIF;;AADA;;;;;;;;;;;;GAAA;AAmEA;;;;;;;;;;;KAAA;AAYA;;;;;;;MAAA;AASA,MAAA;AAEA,wBAAA;AACA;EACE,kBAAA;AApDF;;AAuDA;EACE,WAAA;EACA,SAAA;EACA,mBAAA;AApDF;;AAuDA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,uCAAA;EACA,yDAAA;EAEA,2BAAA;EACA,4BAAA;EACA,wBAAA;AArDF;AAuDE;EACE,8BAAA;AArDJ;;AAyDA;EACE,mBAAA;AAtDF;;AAyDA;EACE,cAAA;AAtDF;;AAyDA;EACE,YAAA;AAtDF;;AAyDA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AAtDF;;AAyDA;EACE,YAAA;AAtDF;;AAwDA;EACE,cAAA;AArDF;;AAwDA;EACE,cAAA;AArDF;;AAwDA;EACE,YAAA;AArDF;;AAwDA;EACE,kBAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AArDF;AAsDE;EACE,WAAA;EACA,kBAAA;AApDJ;;AAwDA;EACE,kBAAA;AArDF;;AAwDA;EACE,YAAA;AArDF;;AAwDA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,wCAAA;AAtDF;;AA0DA;EACE,aAAA;EACA,sCAAA;AAvDF;;AAyDA;EACE,aAAA;EACA,2CAAA;EACA,WAAA;EACA,gBAAA;AAtDF;;AAyDA;EACE,aAAA;EACA,sBAAA;AAtDF;;AAyDA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAtDF;;AAwDA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AArDF;;AAwDA;EACE,aAAA;EACA,mBAAA;AArDF;AAwDE;EACE,eAAA;AAtDJ;AAwDE;EACE,eAAA;AAtDJ;AAwDE;EACE,eAAA;AAtDJ;;AA0DA;EACE,sBAAA;AAvDF;;AA0DA;EACE,aAAA;EAEA,mBAAA;EACA,mBAAA;AAxDF;;AA0DA;EACE,aAAA;EACA,sBAAA;AAvDF;;AAyDA;EACE,iBAAA;AAtDF;;AAwDA;EACE,8BAAA;AArDF;;AAuDA;EACE,8BAAA;AApDF;;AAsDA;EACE,6BAAA;AAnDF;;AAqDA;EACE,uBAAA;AAlDF;;AAoDA;EACE,yBAAA;AAjDF;;AAmDA;EACE,2BAAA;AAhDF;;AAkDA;EACE,mBAAA;AA/CF;;AAiDA;EACE,qBAAA;AA9CF;;AAgDA;EACE,uBAAA;AA7CF;;AA+CA;EACE,qBAAA;AA5CF;;AA8CA;EACE,oBAAA;AA3CF;;AA6CA;EACE,kBAAA;AA1CF;;AA4CA;EACE,sBAAA;AAzCF;;AA2CA;EACE,mBAAA;AAxCF;;AA0CA;EACE,SAAA;AAvCF;;AAyCA;EACE,WAAA;AAtCF;;AAwCA;EACE,WAAA;AArCF;;AAuCA;EACE,SAAA;AApCF;;AAsCA;EACE,QAAA;AAnCF;;AAqCA;EACE,eAAA;AAlCF;;AAoCA;EACE,kBAAA;AAjCF;;AAmCA;EACE,mBAAA;AAhCF;;AAkCA;EACE,oBAAA;AA/BF;;AAiCA;EACE,mBAAA;AA9BF;;AAgCA;EACE,mBAAA;AA7BF;;AA+BA;EACE,qBAAA;AA5BF;;AA8BA;EACE,mBAAA;AA3BF;;AA6BA;EACE,kBAAA;AA1BF;;AA4BA;EACE,cAAA;AAzBF;;AA2BA;EACE,QAAA;AAxBF;;AA0BA;EACE,QAAA;AAvBF;;AAyBA;EACE,UAAA;AAtBF;;AAwBA;EACE,YAAA;AArBF;;AAuBA;EACE,gBAAA;AApBF;;AAsBA;EACE,kBAAA;AAnBF;;AAqBA;EACE,gBAAA;AAlBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AAjBF;;AAmBA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAhBF;;AAkBA;EACE,WAAA;AAfF;;AAiBA;EACE,UAAA;AAdF;;AAgBA;EACE,YAAA;AAbF;;AAiBA;EACE,eAAA;AAdF;AAgBE;EAGE,mDAAA;AAhBJ;;AAmBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;AAhBF;AAiBE;EACE,YAAA;EACA,SAAA;AAfJ;;AAkBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;AAfF;;AAkBA;EACE,qBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAfF;;AAqBA;EACE,WAAA;EAEA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAnBJ;;AAoCA;EAKE;IACE,YAAA;EArCF;EAuCA;IACE,YAAA;IACA,YAAA;EArCF;AACF;AAwCA;EAME;IACE,YAAA;EA3CF;AACF;AA8CA;EACE;IACE,YAAA;EA5CF;AACF;AAsDA;EACE,oBAAA;EACA,0BAAA;EACA,qBAAA;EACA,mBAAA;EACA,0BAAA;AApDF;;AAuDA;EACE,iBAAA;AApDF;;AAuDA;EACE;IACE,YAAA;EApDF;AACF","sourcesContent":["@import \"../../../../node_modules/modern-normalize/modern-normalize.css\";\n@import url(\"https://fonts.googleapis.com/css2?family=Noto+Sans&family=Roboto:wght@300;500&display=swap\");\n:root {\n  --app-height: 100%;\n}\n\n#root {\n  height: 100%;\n  /* min-width: 1024px; */\n}\n\nhtml,\nbody {\n  font-size: 13px;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  /* width: 100vw;\n   */\n  height: 100%;\n  /* height: 100vh; */\n  /* @media not all and (hover:hover) {\n       height: var(--app-height);\n   } */\n}\n.App {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  color: #426ba6;\n\n  width: 100%;\n  height: 100%;\n  /* height: var(--app-height);     */\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  background-color: #f4f4f4;\n}\n\n.textFormat {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  color: #426ba6;\n}\n\n.App,\nbutton,\ninput,\ntable {\n  font-family: \"Roboto\";\n  color: #426ba6;\n}\n\n.App__container {\n  width: 100%;\n  /* max-width: 1980px;\n  min-width: 1024px; */\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  overflow-y: auto;\n\n  /* padding-bottom: 4.2em; */\n\n  /* overflow-x: scroll; */\n  table {\n    font-size: 11px;\n    line-height: 12px;\n  }\n  .fixed_button {\n    font-size: 13px;\n  }\n}\n.limitedSize {\n  width: 100%;\n  max-width: 1980px;\n  margin-top: 4.2em;\n  height: calc(100% - 4.2em);\n  border: 6px solid #a3b9d9;\n  border-top: 10px solid #a3b9d9;\n  border-radius: 1px 1px 1px 1px;\n  position: relative;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  min-height: calc(576px - 4.2em);\n}\n.limitedSize__container {\n  width: 100%;\n  min-width: 1012px;\n  position: relative;\n\n  height: 100%;\n  overflow-x: visible;\n  padding: 0.5em 1.5em 0 1.5em;\n}\n.limitedSize_label {\n  position: absolute;\n  display: block;\n  top: -2.5em;\n  left: -6px;\n  font-size: 1em;\n  font-weight: 400;\n  color: #426ba6;\n  background-color: #a3b9d9;\n  border-radius: 1px 1px 1px 0px;\n  padding: 0 0.9em 0 1.1em;\n  line-height: 1.5em;\n}\n.limitedSize__container.controlled {\n  padding-bottom: 2.5em;\n}\n.overflow_container {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow-x: auto;\n}\n\ninput {\n  font-size: 1em;\n}\ninput[type=\"checkbox\"] {\n  width: 1.2em;\n  height: 1.2em;\n}\n\n/* @media screen and (min-width: 1805px) {\n  .App{\n    font-size: 15px;\n    line-height: 18px;\n  }\n  .App table{\n    font-size: 13px;\n    line-height: 15px;\n  }\n  .error{\n    font-size: 13px;\n  }\n} */\n// @media screen and (min-width: 1024px) {\n//   .App {\n//     font-size: 11px;\n//     line-height: 12px;\n//   }\n//   .App table {\n//     font-size: 11px;\n//     line-height: 12px;\n//   }\n//   .fixed_button {\n//     font-size: 11px;\n//   }\n// }\n\n// @media screen and (max-width: 1024px) {\n//   .App {\n//     font-size: 11px;\n//     line-height: 12px;\n//   }\n//   .App table {\n//     font-size: 11px;\n//     line-height: 12px;\n//   }\n//   .fixed_button {\n//     font-size: 11px;\n//   }\n// }\n// @media screen and (min-width: 1440px) {\n//   .App {\n//     font-size: 1rem;\n//     line-height: 1.1rem;\n//   }\n//   .App table {\n//     font-size: 1rem;\n//     line-height: 1.1rem;\n//   }\n//   .fixed_button {\n//     font-size: 1rem;\n//   }\n// }\n\n// @media screen and (min-width: 1905px) {\n//   .App {\n//     font-size: 1.2rem;\n//     line-height: 1.3rem;\n//   }\n//   .App table {\n//     font-size: 1.2rem;\n//     line-height: 1.3rem;\n//   }\n//   .fixed_button {\n//     font-size: 1.1rem;\n//   }\n// }\n/* @media screen and (min-width: 3740px) {\n  .App {\n    font-size: 1.9rem;\n    line-height: 2em;\n  }\n  .fixed_button{\n    font-size: 1.7rem;\n  }\n  .App table {\n    font-size: 1.8rem;\n    line-height: 1.9rem;\n  } */\n/* .App .fieldWithSample input[type=\"checkbox\"]{\n    width: 2rem;\n    height: 2rem;\n  }\n  .App input[type=checkbox]{\n    width: 1.2em;\n    height: 1.2em;\n  }  */\n\n/* } */\n\n/* swal password styles*/\n.swalPasswordWrapper {\n  position: relative;\n}\n\n.swalPasswordInput {\n  width: 100%;\n  margin: 0;\n  padding-right: 40px;\n}\n\n.swalShowPasswordBtn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  transition: transform 200ms ease-in-out;\n  background-image: url(\"../../../images/icons/openEye.png\");\n\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n\n  &:active {\n    transform: translate(0px, 1px);\n  }\n}\n\n.labelWrap {\n  white-space: nowrap;\n}\n\n.db {\n  display: block;\n}\n\n.flexG {\n  flex-grow: 1;\n}\n\n.row {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.fGrow {\n  flex-grow: 1;\n}\n.fShrink {\n  flex-shrink: 1;\n}\n\n.centered {\n  margin: 0 auto;\n}\n\n.centeredFull {\n  margin: auto;\n}\n\n.br {\n  border-radius: 5px;\n}\n\nh1 {\n  font-weight: 500;\n  line-height: 15.23px;\n  font-size: 1em;\n  margin-bottom: 10px;\n  &.centered {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n.tac {\n  text-align: center;\n}\n\n.project_form {\n  height: 100%;\n}\n\n.list_container {\n  width: 100%;\n  height: 120px;\n  overflow-x: hidden;\n  background: #ffffff;\n  margin-bottom: 5px;\n\n  border: #426ca681;\n}\n\n//grid\n.grid2_3 {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr 1fr 1fr;\n}\n.grid2_5 {\n  display: grid;\n  grid-template: 2fr 1fr / 1fr 1fr 1fr 1fr auto;\n  width: 100%;\n  column-gap: 10px;\n}\n/// flex\n.flex_form {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex_container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.fc {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.fc {\n  display: flex;\n  align-items: center;\n  // justify-content: space-between;\n\n  .fi50 {\n    flex-basis: 50%;\n  }\n  .fi60 {\n    flex-basis: 60%;\n  }\n  .fi70 {\n    flex-basis: 70%;\n  }\n}\n\n.fdc {\n  flex-direction: column;\n}\n\n.fcc {\n  display: flex;\n  // flex-wrap: nowrap;\n  flex-direction: row;\n  align-items: center;\n}\n.fcCol {\n  display: flex;\n  flex-direction: column;\n}\n.nowrap {\n  flex-wrap: nowrap;\n}\n.space-between {\n  justify-content: space-between;\n}\n.jcsb {\n  justify-content: space-between;\n}\n.jcsa {\n  justify-content: space-around;\n}\n.jcc {\n  justify-content: center;\n}\n.jcfe {\n  justify-content: flex-end;\n}\n.jcfs {\n  justify-content: flex-start;\n}\n.aic {\n  align-items: center;\n}\n.aife {\n  align-items: flex-end;\n}\n.aist {\n  align-items: flex-start;\n}\n.aibl {\n  align-items: baseline;\n}\n.aistr {\n  align-items: stretch;\n}\n.alsc {\n  align-self: center;\n}\n.fd {\n  flex-direction: column;\n}\n.fdr {\n  flex-direction: row;\n}\n.gap {\n  gap: 1rem;\n}\n.gap0_7 {\n  gap: 0.7rem;\n}\n.gap1_5 {\n  gap: 1.5rem;\n}\n.gap2x {\n  gap: 2rem;\n}\n.gap5 {\n  gap: 5px;\n}\n.halfBasis {\n  flex-basis: 50%;\n}\n.pl {\n  padding-left: 1rem;\n}\n.pr {\n  padding-right: 1rem;\n}\n.pb {\n  padding-bottom: 1rem;\n}\n.mba {\n  margin-bottom: auto;\n}\n.mb {\n  margin-bottom: 1rem;\n}\n.mb1_5x {\n  margin-bottom: 1.5rem;\n}\n.mb2x {\n  margin-bottom: 2rem;\n}\n.mb5 {\n  margin-bottom: 5px;\n}\n.noShrink {\n  flex-shrink: 0;\n}\n.g2 {\n  gap: 2em;\n}\n.g1 {\n  gap: 1em;\n}\n.g15 {\n  gap: 1.5em;\n}\n.fGrow {\n  flex-grow: 1;\n}\n.mt {\n  margin-top: 1rem;\n}\n.mt0_5 {\n  margin-top: 0.5rem;\n}\n.mt2x {\n  margin-top: 2rem;\n}\n.mt3x {\n  margin-top: 3rem;\n}\n///////////\n.page_container {\n  margin: 0 1%;\n  padding-top: 5px;\n  height: 100%;\n}\n.form_wrapper {\n  width: 100%;\n  min-width: 100%;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow-x: visible;\n  position: relative;\n}\n.w100 {\n  width: 100%;\n}\n.w90 {\n  width: 90%;\n}\n.h100 {\n  height: 100%;\n}\n\n/////\n.reactTableRow {\n  cursor: pointer;\n\n  &:hover,\n  // &:focus,\n  &:active {\n    background-color: #bfcde24b;\n  }\n}\n.app__logo {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  z-index: 10;\n  &.left {\n    right: unset;\n    left: 5px;\n  }\n}\n.app__logo--right {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  z-index: 10;\n}\n\n.tdn {\n  text-decoration: none;\n}\n\nbutton.bigBtn {\n  height: 2.5rem;\n  padding: 8px;\n  border-radius: 7px;\n}\n\n.qrContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  // width: 80%;\n  // height: 70%;\n}\n\n#qrCodeContainer2 {\n  width: 100%;\n  // height: 100%;\n  border: 1px solid #a3b9d9;\n  background: white;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  video {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n\n  // @media (min-height: 600px) {\n  //   width: 160px;\n  //   height: 160px;\n  // }\n  // @media (min-height: 660px) {\n  //   width: 200px;\n  //   height: 200px;\n  // }\n  // @media (min-height: 760px) {\n  //   width: 210px;\n  //   height: 210px;\n  // }\n}\n\n@media screen and (min-width: 280px) {\n  // .qrContainer {\n  //   width: 230px;\n  //   height: 460px;\n  // }\n  .skuInput {\n    width: 150px;\n  }\n  button.bigBtn {\n    height: 2rem;\n    padding: 6px;\n  }\n}\n\n@media screen and (min-width: 370px) {\n  // .qrContainer {\n  //   width: 300px;\n  //   height: 600px;\n  // }\n\n  div input.skuInput {\n    width: 200px;\n  }\n}\n\n@media screen and (min-width: 500px) {\n  div input.skuInput {\n    width: 300px;\n  }\n}\n\n@media screen and (min-width: 769px) {\n  // div input.qrContainer {\n  //   width: 500px;\n  //   height: 1000px;\n  // }\n}\n\n.Toastify__toast-container--top-center {\n  top: 30vh !important;\n  position: fixed !important;\n  width: 90% !important;\n  left: 5% !important;\n  transform: none !important;\n}\n\n.skuActionTable {\n  max-height: 50dvh;\n}\n\n@media screen and (max-height: 600px) {\n  .skuActionTable {\n    height: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
